// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const LOG_TYPES = {
  SIMPLE_LOGS: 'SIMPLE_LOGS',
  CUMULATED_LOGS: 'CUMULATED_LOGS',
};
